<template>
	<div
		class="dashboard__content__search d-flex justify-content-between align-items-center"
	>
		<div
			class="dashboard__content__search__inner-wrap d-flex align-items-center flex-row-reverse"
		>
			<input
				type="text"
				placeholder="People, groups, messages"
				v-model="query"
				class="dashboard__content__search__input"
			/>

			<i class="fal fa-search"></i>
		</div>
		<button class="chat-hoverable-btn">
			<i class="fal fa-plus"></i>
		</button>
		<transition name="dropdown-animation">
			<div v-show="query" class="dashboard__content__search__dropdown">
				<simplebar>
					<div class="dashboard__content__search__dropdown__result">
						<div
							v-for="user in users"
							:key="'user-' + user._id"
							class="dashboard__content__search__dropdown__result__item d-flex justify-content-between align-items-center"
						>
							<div class="d-flex">
								<profile-picture
									class="dashboard__content__search__dropdown__result-item__profile-picture mr-3"
									:img="user.profilePicture"
									:text="user.name"
								></profile-picture>
								<div class="d-flex flex-column">
									<p class="text--primary">
										{{ user.name }}
									</p>
									<p class="text--secondary">
										{{ user.nickname }}
									</p>
								</div>
							</div>
							<button
								class="chat-hoverable-btn"
								@click="ADD_FRIEND(user.nickname)"
							>
								<i class="fal fa-plus"></i>
							</button>
						</div>
						<div
							v-if="!loading && users.length < 1"
							class="dashboard__content__search__dropdown__result__item not-found"
						>
							<p>Not Found</p>
						</div>
						<div
							v-show="loading"
							ref="loadingWrapper"
							class="dashboard__content__search__dropdown__result__loader dashboard__content__search__dropdown__result__item"
						></div>
					</div>
				</simplebar>
			</div>
		</transition>
	</div>
</template>
<script>
import { protectedAxiosInstance } from "@/utils/axiosConfig"
import { debounce } from "lodash"
import simplebar from "simplebar-vue"
import ProfilePicture from "./ProfilePicture.vue"
import { mapActions } from "vuex"
export default {
	data() {
		return {
			query: "",
			users: [],
			dropdownShown: false,
			loading: false
		}
	},
	components: {
		ProfilePicture,
		simplebar
	},
	watch: {
		async query(query) {
			this.loading = true
			this.users = []
			if (!query) {
				return
			}
			await this.debouncedFindResults()
		}
	},
	methods: {
		debouncedFindResults: debounce(async function() {
			await this.findResults()
		}, 500),
		async findResults() {
			if (this.query) {
				const {
					data: { data: users }
				} = await protectedAxiosInstance.get(
					`/users?query=${this.query}`
				)

				this.users = [...users]
				this.loading = false
			}
		},
		openLoading() {
			const target = this.$refs["loadingWrapper"]
			console.log(target)
			this.$vs.loading({
				target,
				color: "#362eb8",
				type: "corners"
			})
		},
		...mapActions(["ADD_FRIEND"])
	},
	mounted() {
		this.openLoading()
	}
}
</script>
